import { ContentType } from '../../../types/contentTypes';
import ContentTypeIcon from '../../atoms/content-type-icon/ContentTypeIcon';

interface ContentTypeIconListProps {
  contentTypes: ContentType[];
}

export default function ContentTypeIconList({ contentTypes }: ContentTypeIconListProps) {
  const ContentTypeIcons = contentTypes.map((type, index) => {
    return <ContentTypeIcon className="mr-1" type={type} key={index} />;
  });

  return (
    <span className="flex items-center">
      {ContentTypeIcons.length <= 3 ? (
        ContentTypeIcons
      ) : (
        <>
          {ContentTypeIcons.slice(0, 2)} {'+'} {ContentTypeIcons.length - 2}
        </>
      )}
    </span>
  );
}
